import { jsx as _jsx } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { CouponText } from "../../OrderFlow/components/Coupons/CouponForm-types";
import { useCouponForm } from "../../OrderFlow/components/Coupons/useCouponForm";
import { ModalContent } from "../../Shared/components/Modal";
import { useTheme, TextField, DialogActions } from "@mui/material";
import { usePayment } from "../../Account/BillingInformation/Shared/hooks/Payment/usePayment";
import { LoadingButton } from "@mui/lab";
export const useCheckoutCouponModal = () => {
    const theme = useTheme();
    const { updatePayInitiation } = usePayment();
    const { onSubmit, showModal, closeModal, control, loading } = useCouponForm(updatePayInitiation);
    return {
        showCouponForm: () => {
            showModal({
                title: CouponText.APPLY_COUPON,
                content: (_jsx(ModalContent, Object.assign({ style: { marginBottom: theme.spacing(1) } }, { children: _jsx("form", Object.assign({ id: "checkoutCouponApply", onSubmit: onSubmit }, { children: _jsx(Controller, { control: control, name: "couponCode", render: ({ field, fieldState: { error } }) => (_jsx(TextField, Object.assign({}, field, { fullWidth: true, label: CouponText.COUPON_CODE, variant: "outlined", error: Boolean(error), helperText: Boolean(error) && (error === null || error === void 0 ? void 0 : error.message) }))) }) })) }))),
                actions: (_jsx(DialogActions, Object.assign({ style: {
                        padding: theme.spacing(2.75, 3.5, 2.5),
                        borderTop: `1px solid #DEDDDE`,
                    } }, { children: _jsx(LoadingButton, Object.assign({ size: "medium", color: "primary", variant: "contained", type: "submit", form: "checkoutCouponApply", fullWidth: true, loading: loading }, { children: CouponText.CONFIRM })) }))),
                closeModalFunc: () => {
                    closeModal();
                },
            });
        },
    };
};
